import React from "react";

const cars = [
  {
    name: "Hyundai Aura",
    role: "Sedan Cab",
    image: "/images/fleets/aura.jpg",
  },
  {
    name: "Maruti Dzire",
    role: "Comfort Sedan Cab",
    image: "/images/fleets/Dzire.jpg",
  },
  {
    name: "Tempo Traveller",
    role: "Group Travel Vehicle",
    image: "/images/fleets/tempo-traveller.jpg",
  },
];

const TeamStyleOne = () => {
  return (
    <section className="team-style-one  ">
      {/* Background Image */}
      <img
        src="images/background/team-bg-1-1.png"
        className="team-bg"
        alt="Background"
      />

      <div className="container p-0 ">
        {/* Section Title */}
        <div className="block-title text-center">
          <div className="dot-line"></div>

          <p className="light-2">Our fleet vehicles</p>

          <h2 className="light">Available Cars</h2>
        </div>

        {/* Cars Row */}
        <div className="row">
          {cars.map((car, index) => (
            <div className="col-lg-4" key={index}>
              <div className="single-team-one">
                {/* Car Image */}
                <div className="image-block">
                  <img src={car.image} alt={car.name} />
                </div>

                {/* Car Info */}
                <div className="text-block">
                  <h3>{car.name}</h3>

                  <p>{car.role}</p>

                  {/* Optional CTA instead of social icons */}
                  <div className="social-block">
                    {/* <a href="#">
                      Book Now
                    </a> */}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TeamStyleOne;